type BreadcrumbItem = {
  name: string;
  item: string;
};

type Route = {
  link: string;
  text: string;
};

type BuildBreadcrumbsFromRoutesParams = {
  linkHome: string;
  routes: Route[];
};

export const buildBreadcrumbsFromRoutes = ({
  linkHome,
  routes,
}: BuildBreadcrumbsFromRoutesParams): BreadcrumbItem[] => {
  return [
    {
      name: linkHome,
      item: 'https://dreamisland.ru/',
    },
    ...routes.map((route) => ({
      name: route.text,
      item: `https://dreamisland.ru${route.link}`,
    })),
  ];
};

type BuildBreadcrumbsFromItemsParams = {
  linkHome: string;
  items: BreadcrumbItem[];
};

export const buildBreadcrumbsFromItems = ({
  linkHome,
  items,
}: BuildBreadcrumbsFromItemsParams): BreadcrumbItem[] => {
  return [
    {
      name: linkHome,
      item: 'https://dreamisland.ru/',
    },
    ...items,
  ];
};

type OurObject = {
  name: string;
  code: string;
};

type BuildBreadcrumbsForLocationParams = {
  linkHome: string;
  objectsText: string;
  ourObject?: OurObject;
  locationName: string;
  locationUrl: string;
};

export const buildBreadcrumbsForLocation = ({
  linkHome,
  objectsText,
  ourObject,
  locationName,
  locationUrl,
}: BuildBreadcrumbsForLocationParams): BreadcrumbItem[] => {
  const items: BreadcrumbItem[] = [];

  if (ourObject) {
    items.push({
      name: objectsText,
      item: 'https://dreamisland.ru/objects',
    });
    items.push({
      name: ourObject.name,
      item: `https://dreamisland.ru/objects/${ourObject.code}`,
    });
  }

  items.push({
    name: locationName,
    item: locationUrl,
  });

  return buildBreadcrumbsFromItems({ linkHome, items });
};
